import React from 'react'

const HexaImage = (props) => {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 90">
            <defs>
                <pattern
                    id={props.image}
                    patternUnits="userSpaceOnUse"
                    width="100"
                    height="100"
                >
                    <image xlinkHref={props.image} x="-25" width="150" height="100" />
                </pattern>
            </defs>
            <polygon
                fill={"url(#" + props.image + ")"}
                points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "
            />
        </svg>
    )
}
export default HexaImage;
